import { modularScale, palette, pxToRem, Text } from "@ottatech/design";
import styled from "styled-components";

import { Pencil } from "../../pages/Jobs/icons/Pencil";

const InlineText = styled(Text)`
  display: inline;
`;

const ApplyButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;

  width: ${pxToRem(16)};
  margin-right: ${modularScale()};

  svg {
    height: 100%;
    width: 100%;
    path {
      fill: ${palette.brand.black};
    }
  }
`;

export function ApplyViaOttaButtonContent({
  isApplyViaOtta = true,
}: {
  isApplyViaOtta?: boolean;
}): React.ReactElement {
  return (
    <ApplyButtonContent>
      <IconWrapper>
        <Pencil />
      </IconWrapper>
      <Text bold>
        Apply
        {isApplyViaOtta && <InlineText size={-1}> via Otta</InlineText>}
      </Text>
    </ApplyButtonContent>
  );
}
